import axios from 'axios';
import aemClient from '../configurations/aemClient';
import { useAtom } from 'jotai';
import { aemContent, aemError, aemDisclosureItems } from '../state/globalState';
import { useUniversalContext } from '@cxc/react-universal-components';
import { getCountryFromLanguage } from '../utils/utils';
import { createSuperScriptLinkHtml } from '../components/SuperScriptLink/SuperScriptLink';

const extractDisclosureKeys = (data: any): Map<number, Disclosures> => {
    const disclosuresMap = new Map<number, Disclosures>();
    let disclosureNumber = 0;
    disclosureNumber = traverseJsonDocument(data, disclosuresMap, disclosureNumber);
    return disclosuresMap;
};

const traverseJsonDocument = (obj: any, disclosuresMap: Map<number, any>, disclosureNumber: number): number => {
    if (typeof obj === 'object') {
        for (const key in obj) {
            if (key === 'disclosures' && Array.isArray(obj[key])) {
                obj[key].forEach((item: any) => {
                    const disclosure = item.disclosure;
                    if (disclosure?.disclosureKey && !disclosuresMap.has(disclosure.disclosureKey)) {
                        disclosuresMap.set(disclosure.disclosureKey, {
                            disclosureNumber: ++disclosureNumber,
                            disclosureText: disclosure.disclosureText,
                        });
                    }
                });
            } else if (Array.isArray(obj[key]) || typeof obj[key] === 'object') {
                disclosureNumber = traverseJsonDocument(obj[key], disclosuresMap, disclosureNumber);
            }
        }
    }
    return disclosureNumber;
};

const useAEMFetch = () => {
    const [, setAem] = useAtom(aemContent);
    const [, setDisclosureItems] = useAtom(aemDisclosureItems);
    const [, setError] = useAtom(aemError);
    const { language } = useUniversalContext();

    const source = axios.CancelToken.source();
    const getAEMvalues = () => {
        const country = getCountryFromLanguage(language);
        return new Promise(async (resolve, reject) => {
            try {
                const { status, data } = await aemClient.get(`/content/dam/fordpro/${country}/${language}/e-switch-assist/endpoint.pro-model.json`);
                if (status === 200) {
                    resolve(status);
                    let aemResponseData = JSON.stringify(data);

                    // below logic extracts disclosure items from the AEM payload and
                    // creates super scripts for disclosures as links that navigate to
                    // the disclosure section found at the botton of the screen
                    const parsedAemDisclosureItems = extractDisclosureKeys(data.data.componentRefs);
                    parsedAemDisclosureItems.forEach((value: Disclosures, key: number) => {
                        if (aemResponseData.includes('@@' + key)) {
                            aemResponseData = aemResponseData.replaceAll('@@' + key, createSuperScriptLinkHtml(value.disclosureNumber));
                            value.isGlobalDisclosure = false;
                        } else {
                            value.isGlobalDisclosure = true;
                        }
                    });

                    setAem(() => JSON.parse(aemResponseData).data.componentRefs);
                    setDisclosureItems(() => parsedAemDisclosureItems);
                }
            } catch (error) {
                setError(error);
                reject(error);
            }
        });
    };

    const cancelRequests = () => {
        source.cancel();
    };
    return [getAEMvalues, setAem, cancelRequests];
};

export default useAEMFetch;
